<div class="navbar">
  <div class="navbar-logo">
    <img src="/honkajoki-logo.png" alt="logo" class="navbar-logo-image" width="200" height="23" />
    <div class="navbar-logo-text">MasterData</div>
  </div>
  <div class="navbar-links">
    <a class="navbar-links-link" routerLink="/app/create" routerLinkActive="mod-active">{{ 'NAV.CREATE_NEW' | translate }}</a>
    <a class="navbar-links-link" routerLink="/app/view" routerLinkActive="mod-active">{{ 'NAV.VIEW' | translate }}</a>
    <a class="navbar-links-link" routerLink="/app/pricing" routerLinkActive="mod-active">{{ 'NAV.PRICING' | translate }}</a>
  </div>
  <div class="navbar-user-section">
    <div class="navbar-user">
      <div class="navbar-user-info">
        <mat-icon svgIcon="user" class="navbar-user-info-icon"></mat-icon>
        <div class="navbar-user-info-name">{{ userName() }}</div>
      </div>
      <div class="navbar-user-support">
        <a>{{ 'NAV.SUPPORT' | translate }}</a>
      </div>
    </div>
  </div>
</div>
